import { render, staticRenderFns } from "./ManufactureProductSpecsModal.vue?vue&type=template&id=575d1f94&"
import script from "./ManufactureProductSpecsModal.vue?vue&type=script&lang=js&"
export * from "./ManufactureProductSpecsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports